import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
// import { Course } from 'src/app/models/course.model';
// import { CourseService } from 'src/app/services/course.service';
// import { Store } from 'store';
// import { User, VisitedCourse } from 'src/app/models/user.model';
// import { Exercise } from 'src/app/models/exercise.model';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Store } from 'src/app/core/store/store';
import { Exercise } from 'src/app/shared/models/exercise.model';
import { User } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';

@Component({
  selector: 'app-exercise-result',
  templateUrl: './exercise-result.component.html',
  styleUrls: ['./exercise-result.component.css']
})
export class ExerciseResultComponent implements OnInit {

  @Input() courseId: any;
  @Input() courseTitle: any;
  @Input() courseFeedback: any;
  @Input() nextItem: any;
  @Input() exerciseDetails: any;
  @Input() exerciseId: any;
  @Input() exerciseData: Exercise = null;
  isResultPublished: boolean = false;
  viewFeedbackScreen: boolean = false;
  totalPoints: number = 0;
  totalExPoints: number = 0;
  answers: any = {};
  points: any = {};
  correctAnswers: any = {};
  variableFeedback: any = {};
  attemptedExercise: any;
  userSubscription: Subscription;
  taFeedbacks: any = {};
  private unsubscribe$ = new Subject();
  
  constructor(private courseService: CourseService, private store: Store) { }

  ngOnInit() {

    this.userSubscription = this.store.select<User>('user').subscribe(user => {
      if (user) {
        // this.attemptedExercise = user.visitedCourses.find(el => el.id === this.courseId).exercises.find(ex => ex.id == this.exerciseId)
        // this.getExerciseScores();
        // this.isResultPublished = this.attemptedExercise && this.attemptedExercise.status == "PUBLISHED";
      }
    });

    this.store.select('currentUserCourse').pipe(takeUntil(this.unsubscribe$)).subscribe((course: any) => {
      if(course) {
        this.attemptedExercise = course.exercises.find(ex => ex.id == this.exerciseId);
        this.getExerciseScores();
        this.isResultPublished = this.attemptedExercise && this.attemptedExercise.status == "PUBLISHED";
      }
    });

    !this.exerciseData && this.courseService.getExercise(this.exerciseId).subscribe(ex => {
      if (ex) {
        this.exerciseData = ex;
      }
    })
  }

  getExerciseScores() {
    this.totalPoints = 0;
    this.totalExPoints = 0;
    if (this.attemptedExercise && this.attemptedExercise.answers) {
      this.attemptedExercise.answers.forEach((el) => {
        this.totalPoints += el.points;
        this.totalExPoints += el.total;
        if (Object.keys(el).length) {
          this.points[el.elementId] = { point: el.points, total: el.total };
          this.answers[el.elementId] = el.answer;
          this.taFeedbacks[el.elementId] = { feedback: el.feedback, rowsFeedback: el.rowsFeedback, rows: el.rows, cells: el.cells, elementId: el.elementId }
          this.correctAnswers[el.elementId] = el.correctAnswers;
          this.variableFeedback[el.elementId]=el.answerFeedback;
        }
      });
    }
  }


  ngOnDestroy(): void {
    this.userSubscription && this.userSubscription.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  next() {
    this.courseService.setcurrentPlayedItem(this.nextItem.id);
  }

  viewFeedback() {
    this.viewFeedbackScreen = true;
  }
}
